import React, { useState } from "react";
import { IconButton, Link, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import palette from "src/theme/palette";
import {
  GO_LIVE_BANNER_LINK,
  GO_LIVE_BANNER_TEXT,
  buildSalesforceAssetsUrl
} from "./SubscriptionTab.consts";

const GoLiveBanner = ({ salesforceAccountId }) => {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      data-testid="go-live-banner"
      sx={{
        backgroundColor: palette.warning[200],
        borderRadius: 1,
        px: 2,
        py: 0.75
      }}
    >
      <Stack direction="row" alignItems="center" gap={1.5}>
        <ErrorOutlineIcon sx={{ color: palette.warning[700], fontSize: 22 }} />
        <Typography variant="body1" sx={{ color: palette.warning[800], py: 1 }}>
          {GO_LIVE_BANNER_TEXT}
          <Link
            href={salesforceAccountId ? buildSalesforceAssetsUrl(salesforceAccountId) : undefined}
            target="_blank"
            rel="noopener noreferrer"
            underline="always"
            data-testid="go-live-banner-link"
            sx={{ color: "inherit", textDecorationColor: "inherit" }}
          >
            {GO_LIVE_BANNER_LINK}
          </Link>
        </Typography>
      </Stack>
      <IconButton
        size="small"
        disableRipple
        aria-label="Dismiss"
        data-testid="go-live-banner-close"
        onClick={() => setDismissed(true)}
        sx={{
          color: palette.warning[800],
          p: 0,
          "&:hover": { backgroundColor: "transparent" }
        }}
      >
        <CloseIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Stack>
  );
};

export default GoLiveBanner;
